import React from "react";
import css from "../css/Mywallet.module.css";
import Rightcontainer from "../Components/Rightcontainer";
import { Link, useHistory } from "react-router-dom";
import Swal from "sweetalert2";

const Mywallet = ({ user }) => {
  // const [user, setUser] = useState();
  const history = useHistory();
  // const navigate = navigate()

  // BASE URL

  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
  const nodeMode = process.env.NODE_ENV;
  if (nodeMode === "development") {
    var baseUrl = beckendLocalApiUrl;
  } else {
    baseUrl = beckendLiveApiUrl;
  }

  const userData = localStorage.getItem("udata");
  const udata = JSON.parse(userData);

  const handleClick = () => {
    // if (udata?.verified === "verified") {
      history.push("/addcase");
    // } else {
    //   Swal.fire({
    //     title: "Complete your KYC",
    //     text: "कृपया 👉 Deposit  add करने से पहले KYC कम्पलीट करें 🙏",
    //     icon: "warning",
    //     confirmButtonText: "Go to Profile",
    //     showCancelButton: true,
    //     cancelButtonText: "Cancel",
    //   }).then((result) => {
    //     if (result.isConfirmed) {
    //       history.push("/profile"); // Change path if your route is different
    //     }
    //   });
    // }
  };

  // const handleClick = () => {
  //   userData?.verified
  //     ? navigate('/addcase')
  //     : Swal.fire({
  //       title: 'Complete your KYC',
  //       text: 'You need to complete your KYC before proceeding.',
  //       icon: 'warning',
  //       confirmButtonText: 'OK',
  //     });
  // };
  //   const walletUpdate =()=>{
  //  io.emit("getprofile", access_token);
  //   io.on("setProfile", (data) => {
  //     setUser(data);
  //   });
  //   }

  //   useEffect(()=>{
  //     walletUpdate()
  //   },[]);

  return (
    <>
      <div className="leftContainer">
        <div className="wallet-modern-page">
          {/* Navigation Header */}
          <div className="wallet-header-nav">
            {/* <Link to="/" className="nav-circle-btn">
              <i className="fa fa-arrow-left"></i>
            </Link> */}
            <h4 className="nav-title ">My Wallet</h4>
            {/* <Link to="/history" className="nav-history-link">
              <i className="fa fa-history"></i> History
            </Link> */}
          </div>

          {/* Verification Status Card */}
          <div className="status-banner">
            <div className="status-content">
              <div className="avatar-group">
                <img src="/images/avatars/new.png" alt="user" />
                <div className="verified-badge"></div>
              </div>
              <div className="status-text">
                <span className="status-label">Account Status</span>

                {udata.verified == "unverified" ? (
                  <span className="status-value">Verification unverified</span>
                ) : (
                  <span className="status-value">Verification Completed</span>
                )}
              </div>
            </div>
          </div>

          {/* Balance Grid */}
          <div className="balance-grid">
            {/* Deposit Card */}
            <div className="balance-card deposit-theme">
              <div className="card-top">
              <span className="card-label">🎮 Game Balance</span>
                <img src="images/rupee.png" alt="rupee" className="coin-icon" />
              </div>
              <div className="card-amount">
                <h2>₹{user && user.Wallet_balance}</h2>
              <p className="mb-0">Ready to join battles</p>
              </div>
              <button onClick={handleClick} className="action-btn-wallet">
                Add Chips
              </button>
            </div>

            {/* Winning Card */}
            <div className="balance-card winning-theme">
              <div className="card-top">
                <span className="card-label">🏆 Reward Balance</span>
                <img src="images/rupee.png" alt="rupee" className="coin-icon" />
              </div>
              <div className="card-amount">
                <h2>₹{user && user.withdrawAmount}</h2>
               <p className="mb-0">Available for instant withdrawal</p>
              </div>
              <Link to="/Withdrawopt" className="action-btn-wallet">
                Withdraw
              </Link>
            </div>
          </div>

          {/* Quick Info Section */}
          <div className="wallet-footer-tip">
            <p>Your transactions are 100% secure and encrypted.</p>
          </div>
        </div>

      
        <div className="rightContainer">
          <div>
            <Rightcontainer />
          </div>
        </div>
      </div>
    </>
  );
};
export default Mywallet;
